import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createColumnHelper, getCoreRowModel, RowSelectionState, Table, useReactTable } from '@tanstack/react-table';

import { TableCell, TableHeader } from '../../../shared';
import { IndexableQuickReply } from '../models/indexableQuickReply';

import './quickReplyTable.scss';

type Props = {
  data: IndexableQuickReply[];
  renderCheckbox: boolean;
};

export const useQuickReplyTable = ({ data, renderCheckbox }: Props): Table<IndexableQuickReply> => {
  const { t } = useTranslation();

  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  const columnHelper = createColumnHelper<IndexableQuickReply>();

  return useReactTable({
    columns: [
      columnHelper.accessor('text', {
        cell: props => <TableCell {...props} withCheckbox={renderCheckbox} />,
        header: props => (
          <TableHeader {...props} title={t('QUICK_REPLIES.LABEL', { count: data.length })} withCheckbox={renderCheckbox} />
        ),
        id: 'KEYWORDS',
      }),
      columnHelper.accessor('description', {
        cell: props => <TableCell {...props} />,
        id: 'Description',
      }),
      columnHelper.accessor('order', {
        cell: props => <TableCell {...props} />,
        id: 'Order',
        size: 50,
      }),
    ],
    data,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getRowId: row => row.id ?? `${row.index}`,
    onRowSelectionChange: setRowSelection,
    state: {
      rowSelection,
    },
  });
};
